<span class="d-block">{{ step6.getautrerenseignement | translate }}</span>
<br/>
<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.rens_Complt.intLibre?.intituleLibre"
[label]="step6.getintitulelibre"
[rule]="'minSize_5|maxSize_2000'"
[name]="getUid()+'_SepAtt_intituleLibre'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"
[value]="initial.rens_Complt.intLibre?.intituleLibreLibelle"
[label]="step6.gettextelibre"
[rule]="'minSize_5|maxSize_2000'"
[type]="'text'"
[name]="getUid()+'_SepAtt_intituleLibreLibelle'">
</app-form-input>